import { CountryJurisdiction, KycCompanyDetails } from 'ah-api-gateways';
import { countryNameFromCC } from 'ah-common-lib/src/helpers/countries';

export function isKYCCountry(countryArray: CountryJurisdiction[] = [], cc?: string) {
  if (!cc) return false;
  return !!countryArray.find((country) => country.countryCode === cc);
}

export function generateKYCAddress(company: KycCompanyDetails, countryCode?: string) {
  let out = '';
  const companyArray = [company.rawAddress, company.zip, company.street, company.city];
  companyArray.forEach((item) => {
    if (item) {
      if (out.length > 0) out = out.concat(', ');
      out = out.concat(item);
    }
  });
  if (countryCode) {
    if (out.length > 0) out = out.concat(', ');
    out = out.concat(countryNameFromCC(countryCode));
  }
  return out;
}
